<template>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="false"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
created() {
       this.itemLink =  `dealers/${this.id}/orders`;
      this.setLink = `dealers/${this.id}/orders`;
},
methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "status",
      fields: [
        
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "orders",
      setLink: "orders",
   columns: [
         {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          sortBy:'id'
        },
        {
          key: "status",
          object: "title",
          title: "Статус",
          disableLink:true
        },
        {
          key: "created_at",
          title: "Создан",
          dateTimeFormat: true,
        },
  
  
        {
          key: "is_paid",
          title: "Оплачен",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
